import React, { SyntheticEvent, useEffect, useState } from "react"
import GoogleMapReact from "google-map-react"
import { useTranslation } from "react-i18next"
import API from "../../common/API"
import Settings from "../../common/Settings"
import { Search, Dropdown } from "semantic-ui-react"
import CRUD from "./genericCRUD/CRUD"

import PinComponent from "./PinComponent"
import { parsedUser } from "../../common/GetCurrentUser"
import { Col, Row } from "react-bootstrap"

interface SearchOptionsDTO {
  title: string
  description: string
  image?: string
  object: any
}

const FieldSelector = (props: any) => {
  const { t } = useTranslation("global")
  const [loading, setLoading] = useState(false)
  const [records, setRecords] = useState([])
  const [photo, setPhoto] = useState<string | null>(null)
  const GoogleMapRef = React.createRef()
  const [zoom, setZoom] = useState(17)
  const [center, setCenter] = useState({ lat: 18.4718609, lng: -69.8923187 })
  const model = props.model
  const [searchOptions, setSearchOptions] = useState<SearchOptionsDTO[]>([])
  const [searchLoading, setSearchLoading] = useState<boolean>(false)
  const [theMap, setTheMap] = useState(null)
  const [theMapsReference, setTheMapsReference] = useState(null)
  const handleApiLoaded = (map, mapsReference) => {
    setTheMap(map)
    setTheMapsReference(mapsReference)
  }

  if (!model) {
    return
  }
  const onHandleZoom = obj => {
    console.log(obj)
    setZoom(obj.zoom)
  }

  const handleSearchChange = React.useCallback(async (e, data) => {
    console.log("the props in search", props)
    props.updateField(model.name, data.value)

    if ((data.value || "").length > 1) {
      //Search remote
      let request: any = null;
      if (props.parentId === "estructuraCompania") {
        request = await API.getAction(
          `${model.dataSource}?search=${data.value}`
        )
      } else
        if (model.name === "careerId") {
          request = await API.postAction(
            "career/search?search=" + data.value
          )
        } else {
          request = await API.postAction(
            "google/searchGeocode?search=" + data.value
          )
        }

      if (request.data.status === "ok" && request.data.response) {
        if (model.name === "careerId" || props.parentId === "estructuraCompania") {
          let response = request.data.response
          let finalResponse = response.map(item => {
            console.log(item)
            return {
              title: item.name,
              description: item.name,
              object: item,
            }
          })
          console.log(finalResponse)
          setSearchOptions(finalResponse)
        } else {
          let response = request.data.response.results
          let finalResponse = response.map(item => {
            console.log(item)
            return {
              title: item.formattedAddress,
              description: item.formattedAddress,
              object: item,
            }
          })
          console.log(finalResponse)
          setSearchOptions(finalResponse)
        }
      }
    }
  }, [])

  const searchCedula = async () => {
    try {
      setLoading(true)
      const requestAPI = await API.getAction(
        "busqueda/nacionales?cedula=" + props.value
      )

      props.resultadosCedula(requestAPI.data.response, model.name)
      console.log(requestAPI)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const searchRNC = async () => {
    try {
      setLoading(true)
      const requestAPI = await API.getAction(
        "dgii/contribuyentes?rnc=" + props.value
      )
      console.log("rnc", requestAPI)
      props.resultadosRnc(requestAPI.data.response)

    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const requestRecords = async () => {
    let query = ""
    if (model.dependOf && props.obj) {
      query = `${model.dependOf}=${props.obj[model.dependOf]}`
    }

    if (model.htmlType === "select" && model.dataSourceLocal) {
      setRecords(
        model.dataSourceLocal.map(item => {
          return {
            value: item.id,
            text: item.name,
          }
        })
      )

      return
    }

    if (model.htmlType === "selectWithPicture" && model.dataSourceLocal) {
      setRecords(
        model.dataSourceLocal.map(item => {
          return {
            value: item.id,
            text: item.name,
            picture: item.picture,
          }
        })
      )

      return
    }

    if (model.datasourceMethod === "POST") {
      let postQuery = {
        Search: null,
        Quantity: 500,
        Page: 0,
      }

      if (model.dependOf) {
        postQuery[model.dependOf] = model.dependOfValue

        if (model.dependOf === "organizationId" && !model.dependOfValue) {
          const user = parsedUser()
          postQuery[model.dependOf] = user.OrganizationId
        }
      }
      let requestAPI: any = await API.postAction(model.dataSource, postQuery)

      if (requestAPI.data.status === "ok") {
        if (model.htmlType === "selectWithPicture") {
          setRecords(
            requestAPI.data.response.map((item, index) => {
              return {
                value: item[model.dataSourceValueField],
                text: item[model.dataSourceTextField],
                picture: item.picture,
              }
            })
          )
          //check if it has a value selected
          if (props.value) {
            let record = requestAPI.data.response.find(
              item => item[model.dataSourceValueField] === props.value
            )
            if (record) {
              setPhoto(record.picture)
            }
          }
        } else {
          setRecords(
            requestAPI.data.response.map((item, index) => {
              return {
                value: item[model.dataSourceValueField],
                text: item[model.dataSourceTextField],
              }
            })
          )
        }
      }
    } else if (model.datasourceMethod === "GET") {
      let requestAPI: any = await API.getAction(
        model.dataSource + (query.length > 0 ? "?" + query : "")
      )
      if (requestAPI.data.status === "ok") {
        requestAPI.data.response.map((item, index) => {
          return {
            value: item[model.dataSourceValueField],
            text: item[model.dataSourceTextField],
          }
        })
      }
    }
  }
  const handleMapClick = obj => {
    console.log(obj)
    setCenter({
      lat: obj.lat,
      lng: obj.lng,
    })
  }

  const uploadImg = async (obj, field) => {
    let file = obj.target.files[0]
    console.log(file)
    // Ensure it's an image
    if (file.type.match(/image.*/)) {
      console.log("An image has been loaded")
      let bodyData = new FormData()
      bodyData.append("path", file)
      const request = await API.postAction(`File/Upload`, bodyData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      if (field.includes("photo")) setPhoto(request.data.response)
      props.updateField(model.name, request.data.response)
      //formik.setFieldValue(field, request.data.response)
    }
  }

  useEffect(() => {

    if ((model.htmlType === "picture" || model.htmlType === "pictureExtranjeros") && props.value) {
      setPhoto(props.value)
      console.log(props.value, model)
    }
    if (model.htmlType === "select" && props.value) {
      if (model.dataSourceLocal) {
        setRecords(
          model.dataSourceLocal.map(item => {
            return {
              value: item.id,
              text: item.name,
            }
          })
        )
      } else {
        requestRecords()
      }
    }

    if (model.htmlType === "selectWithPicture" && props.value) {
      if (model.dataSourceLocal) {
        setRecords(
          model.dataSourceLocal.map(item => {
            return {
              value: item.id,
              text: item.name,
              picture: item.picture,
            }
          })
        )
      } else {
        requestRecords()
      }
    }
  }, [props.value])

  const returnField = () => {
    let recordsExtendedByValue: any = [];
    console.log(model)
    switch (model.htmlType) {
      case "email":
      case "text":
      case "file":
      case "number":
      case "password":
      case "color":
        return (
          <input
            type={model.htmlType}
            className={"form-control"}
            name={model.name}
            value={props.value ?? ""}
            disabled={model.readOnly ?? false}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          />
        )
      case "date":
        return (
          <input
            type={"date"}
            className={"form-control"}
            name={model.name}
            value={props.value ? props.value.substring(0, 10) : ""}
            disabled={model.readOnly ?? false}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          />
        )
      case "datetime":
        return (
          <input
            type={"datetime-local"}
            className={"form-control"}
            name={model.name}
            value={props.value ?? ""}
            disabled={model.readOnly ?? false}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          />
        )
      case "search":
        return (
          <Search
            name={model.name}
            className=""
            value={props.value ?? ""}
            loading={searchLoading}
            results={searchOptions}
            onSearchChange={handleSearchChange}
            resultRenderer={item => {
              console.log(item)
              return <label>{item.title}</label>
            }}
            onResultSelect={(e, data) => {
              console.log(data)

              if (props.parentId === "estructuraCompania") {
                let obj: any = data;
                props.updateField(
                  "identificador",
                  obj.results[0].object.id
                )
                props.updateField(
                  model.name,
                  obj.results[0].object.name
                )
              } else
                if (model.name === "careerId") {
                  props.updateField(
                    model.name,
                    data.result.object.id
                  )
                } else {
                  props.updateField(model.name, data.result.object.formattedAddress)
                }
            }}
          />
        )
      case "searchMap":
        return (
          <Search
            name={model.name}
            className=""
            value={props.value ?? ""}
            loading={searchLoading}
            results={searchOptions}
            onSearchChange={handleSearchChange}
            resultRenderer={item => {
              console.log(item)
              return <label>{item.title}</label>
            }}
            onResultSelect={(e, data) => {
              console.log(data)
              // props.updateField(
              //   model.name,
              //   data.results.object.formattedAddress
              // )
              props.selectMapSearch(data.result.object)
            }}
          />
        )
      case "cedula":

        return (
          <div className="input-group">
            <input
              type="text"
              disabled={model.readOnly ?? false}
              className="form-control"
              name={model.name}
              value={props.value ?? ""}
              onChange={e => {
                console.log(e.target.value)
                props.updateField(model.name, e.target.value)
              }}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  searchCedula()
                }}
              >
                {loading ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  <i className="fa fa-search"></i>
                )}
              </button>
            </div>
          </div>
        )

      case "searchRNC":
        return (
          <div className="input-group">
            <input
              type="text"
              disabled={model.readOnly ?? false}
              className="form-control"
              name={model.name}
              value={props.value ?? ""}
              onChange={e => {
                console.log(e.target.value)
                props.updateField(model.name, e.target.value)
              }}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  searchRNC()
                }}
              >
                {loading ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  <i className="fa fa-search"></i>
                )}
              </button>
            </div>
          </div>
        )
      case "textarea":
        return (
          <textarea
            disabled={model.readOnly ?? false}
            className={"form-control"}
            name={model.name}
            value={props.value ?? ""}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          ></textarea>
        )
      case "crud":
        return (
          <CRUD
            fields={model.subItems}
            getRecordsMethod="post"
            getRecordsPath={model.getRecordsPath}
            deleteRecordPath={model.deleteRecordPath}
            addEditRecordPath={model.addEditRecordPath}
            title={t(model.title) ?? ""}
            isModal={model.isModal ?? false}
            showModal={props.crudShow}
            toggleCRUD={props.crudToggle}
            fieldsList={model.fieldList}
            id={model.name}
            recordButtonsPosition="start"
            headerStyle={"justButtons"}
            parentObject={props.obj}
            parentId={model.dependOf ? model.dependOf : null}
            parentValue={props.obj ? props.obj[model.dependOf] ?? null : null}
          />
        )
      case "picture":
        console.log(model, props.value)
        return (
          <div>
            <input
              type="file"
              disabled={model.readOnly ?? false}
              className="form-control"
              accept="image/*"
              name={model.name}
              onChange={e => {
                uploadImg(e, "photo")
              }}
            // value={props.value ?? ""}
            ></input>
            {photo && (
              <img
                alt=""
                className="img-fluid img-thumbnail my-2"
                style={{ height: "200px", width: "200px", objectFit: "cover" }}
                id="image"
                src={
                  photo.includes("base64")
                    ? photo
                    : `${Settings.BasePath}/files/${photo}`
                }
              />
            )}
          </div>
        )
      case "pictureExtranjeros":
        console.log(model, props.value)
        return (
          <div>
            <input
              type="file"
              disabled={model.readOnly ?? false}
              className="form-control"
              accept="image/*"
              name={model.name}
              onChange={e => {
                uploadImg(e, "photo")
              }}
            // value={props.value ?? ""}
            ></input>
            {photo && (
              <img
                alt=""
                loading="lazy"
                className=" img-thumbnail my-2 img-fluid"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
                onError={(e: any) => {

                  if (
                    e.target.src !==
                    "https://placehold.co/600x400"
                  ) {
                    e.target.src =
                      "https://placehold.co/600x400"
                  }
                }}
                id={"image" + model.name}
                src={
                  photo && photo?.includes("base64")
                    ? photo
                    : photo?.includes("/")
                      ? `${Settings.BasePath}haitianos/${photo}`
                      : `${Settings.BasePath}files/${photo}`
                }
              />
              // <img
              //   alt=""
              //   className="img-fluid img-thumbnail my-2"
              //   style={{ height: "200px", width: "200px", objectFit: "cover" }}
              //   id="image"
              //   src={
              //     photo.includes("base64")
              //       ? photo
              //       : `${Settings.BasePath}/files/${photo}`
              //   }
              // />
            )}
          </div>
        )
      case "map":
        return (
          <GoogleMapReact
            ref={GoogleMapRef}
            // onClick={this.handleClick}
            onClick={handleMapClick}
            yesIWantToUseGoogleMapApiInternals={true}
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            bootstrapURLKeys={{ key: Settings.GoogleMapsAPIKey }}
            style={{
              width: "100%",
              minHeight: "300px",
              // height: "100vh",
              position: "relative",
            }}
            //id={this.props.Element.nombreCampo}
            center={props.value ?? { lat: center.lat, lng: center.lng }}
            defaultZoom={zoom}
            onChange={e => onHandleZoom(e)}
          >
            <PinComponent
              lat={props.value ? props.value.lat : center.lat}
              lng={props.value ? props.value.lng : center.lng}
            />
          </GoogleMapReact>
        )
      case "select":

        if (model.dataSourceLocal) {
          recordsExtendedByValue = model.dataSourceLocal.map((item: any) => {
            return {
              value: item.id,
              text: item.name,
            }
          })
        } else {
          recordsExtendedByValue = records;
        }
        if (props.value && recordsExtendedByValue.filter((item: any) => item.value === props.value).length === 0) {
          recordsExtendedByValue.push({ value: props.value, text: props.value })

        }
        return (
          <Dropdown
            value={props.value ?? "-"}
            search
            className="form-control"
            fluid
            disabled={model.readOnly ?? false}
            onChange={(e: SyntheticEvent, data: any) => {
              console.log(data, e)
              props.updateField(model.name, data.value)
            }}
            onOpen={requestRecords}
            options={
              model.dataSourceLocal
                ? model.dataSourceLocal.map(item => {
                  return {
                    value: item.id,
                    text: item.name,
                  }
                })
                : [...records, { id: "-", name: "-" }]
            }
          />
        )
      case "selectMultiple":

        if (model.dataSourceLocal) {
          recordsExtendedByValue = model.dataSourceLocal.map((item: any) => {
            return {
              value: item.id,
              text: item.name,
            }
          })
        } else {
          recordsExtendedByValue = records;
        }
        if (props.value && recordsExtendedByValue.filter((item: any) => item.value === props.value).length === 0) {
          recordsExtendedByValue.push({ value: props.value, text: props.value })

        }
        return (
          <Dropdown
            value={props.value ? Array.isArray(props.value) ? props.value : props.value.includes(",") ? props.value : props.value.includes("{") ? JSON.parse(props.value) : props.value : "-"}
            search
            className="form-control"
            fluid
            multiple selection
            disabled={model.readOnly ?? false}
            onChange={(e: SyntheticEvent, data: any) => {
              console.log(data, e)
              props.updateField(model.name, data.value)
            }}
            onOpen={requestRecords}
            options={
              model.dataSourceLocal
                ? model.dataSourceLocal.map(item => {
                  return {
                    value: item.id,
                    text: item.name,
                  }
                })
                : [...records, { id: "-", name: "-" }]
            }
          />
        )
      case "selectEmployee":
        console.log(model.dataSourceLocal)
        return (
          <Row className="w-100">
            <Col className="p-0 ps-2">
              <Dropdown
                value={props.value ?? "-"}
                search
                className="form-control"
                fluid
                disabled={model.readOnly ?? false}
                onChange={(e: SyntheticEvent, data: any) => {
                  console.log(data, e)
                  props.updateField(model.name, data.value)
                }}
                onOpen={requestRecords}
                options={
                  model.dataSourceLocal
                    ? model.dataSourceLocal.map(item => {
                      return {
                        value: item.id,
                        text: item.name,
                      }
                    })
                    : records
                }
              />
            </Col>
            <Col xs={"auto"} className="p-0 ms-2">
              <button
                className="btn btn-outline-secondary p-2 jusitify-content-center"
                type="button"
              >
                <i className="fa fa-plus"></i>
              </button>
            </Col>
          </Row>
        )
      case "selectWithPicture":
        return (
          <>
            <Dropdown
              value={props.value ?? "-"}
              search
              className="form-control"
              fluid
              disabled={model.readOnly ?? false}
              onChange={(e: SyntheticEvent, data: any) => {
                console.log(data, e)
                props.updateField(model.name, data.value)
              }}
              onOpen={requestRecords}
              options={
                model.dataSourceLocal
                  ? model.dataSourceLocal.map(item => {
                    return {
                      value: item.id,
                      text: item.name,
                    }
                  })
                  : records
              }
            />
            {model && (
              <img
                alt=""
                className="img-fluid img-thumbnail my-2"
                style={{ width: "200px" }}
                id="image"
                src={`${Settings.BasePath}/files/${photo}`}
              />
            )}
          </>
        )

      case "bool":
        return (
          <button
            className={
              "btn " + (props.value ? "btn-primary" : "btn-outline-primary")
            }
            onClick={e => {
              props.updateField(model.name, !props.value)
            }}
          >
            {props.value ? (
              <i className="fa-solid fa-toggle-on "></i>
            ) : (
              <i className="fa-solid fa-toggle-off"></i>
            )}
          </button>
        )
      case "label":
        return <label>{props.value}</label>
      case "separator":
        return (
          <>
            <h4>{t(model.title)}</h4>
            <hr />
          </>
        )
      case "container":
        return (
          <>
            <h4>{t(model.title)}</h4>
            <hr />
          </>
        )

      default:
        return <></>
    }
  }

  if (!model) {
    return <></>
  }

  console.log("entro", model.dependOf, props.obj)
  if (
    model.dependOf &&
    props.obj &&
    props.obj[model.dependOf] &&
    props.obj[model.dependOf] !== model.dependOfValue
  ) {
    return null
  }
  return (
    <div className={model.containerClass + " my-2"}>
      {model.htmlType !== "separator" && model.htmlType !== "crud" && (
        <label>
          {t(model.title)}
          {model.required && <i className="text-danger">*</i>}
          <br />
        </label>
      )}
      {returnField()}
      {props.errors && props.errors[model.name] ? (
        <div className="invalid text-sm text-danger">
          {props.errors[model.name]}
        </div>
      ) : null}
    </div>
  )
}

export default FieldSelector
